function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AxiosError } from "axios";
/**
 * Default name for the retry header used to track the number of retries.
 */ export var RETRY_HEADER = "x-retry-count";
/**
 * Sets the retry header on the request instance.
 * @param retryHeader
 */ function setRetryHeader(retryHeader) {
    if (retryHeader === void 0) retryHeader = RETRY_HEADER;
    return function(config) {
        config.headers[retryHeader] = config.headers[retryHeader] || 0;
        return config;
    };
}
/**
 * Sets up the Retry Logic Interceptor.
 * @param httpClient The HttpClient instance.
 * @param {RetryOptions} retryOptions  The options for the retry logic. Controls the status codes to retry on, the limit of retries, and an optional header (overrider) to track the number of retries.
 * @param options Options for the interceptor.
 * @returns Request Interceptor Number.
 */ export var setReqRetryInterceptor = function(httpClient, retryOptions, options) {
    if (options === void 0) options = {};
    var _options_synchronous = options.synchronous, synchronous = _options_synchronous === void 0 ? true : _options_synchronous, runWhen = options.runWhen, _options_onSuccess = options.onSuccess, onSuccess = _options_onSuccess === void 0 ? setRetryHeader(retryOptions.retryHeader) : _options_onSuccess, _options_onError = options.onError, onError = _options_onError === void 0 ? function(err) {
        return err;
    } : _options_onError;
    return httpClient.axios.interceptors.request.use(onSuccess, onError, {
        synchronous: synchronous,
        runWhen: runWhen
    });
};
function retryRequest(_) {
    return _retryRequest.apply(this, arguments);
}
function _retryRequest() {
    _retryRequest = _async_to_generator(function(param) {
        var config, httpClient, retryDelay, hasRetriedCount, retryCount, requestRetryOptions;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    config = param.config, httpClient = param.httpClient, retryDelay = param.retryDelay, hasRetriedCount = param.hasRetriedCount;
                    retryCount = Number(hasRetriedCount) + 1;
                    requestRetryOptions = _extends({}, config, {
                        headers: _extends({}, config.headers, _define_property({}, RETRY_HEADER, retryCount))
                    });
                    if (!retryDelay) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, retryDelay);
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        httpClient.request(requestRetryOptions)
                    ];
            }
        });
    });
    return _retryRequest.apply(this, arguments);
}
/**
 * Handles the request retry logic.
 * @param {HttpClient} httpClient The http client instance.
 * @param {RetryOptions} retryOptions The options for the retry logic.
 */ function handleRequestRetryError(httpClient, retryOptions) {
    var _retryOptions_retryStatusCodes = retryOptions.retryStatusCodes, retryStatusCodes = _retryOptions_retryStatusCodes === void 0 ? [] : _retryOptions_retryStatusCodes, _retryOptions_retryHeader = retryOptions.retryHeader, retryHeader = _retryOptions_retryHeader === void 0 ? RETRY_HEADER : _retryOptions_retryHeader, retryLimit = retryOptions.retryLimit, retryTimeout = retryOptions.retryTimeout, retryDelay = retryOptions.retryDelay;
    return /*#__PURE__*/ _async_to_generator(function(err) {
        var shouldRetryStatus, shouldRetryTimeout, hasRetriedCount, isUnderLimit, isNetworkError;
        return _ts_generator(this, function(_state) {
            if (err instanceof AxiosError) {
                shouldRetryStatus = false;
                shouldRetryTimeout = false;
                if (err.config) {
                    hasRetriedCount = err.config.headers[retryHeader];
                    // Bail out in case the header is not present.
                    if (typeof hasRetriedCount === "undefined") {
                        throw err;
                    }
                    isUnderLimit = Number(hasRetriedCount) < retryLimit;
                    if (err.response) {
                        // Check if it should retry
                        shouldRetryStatus = retryStatusCodes.includes(err.response.status);
                    } else {
                        isNetworkError = err.code === "ECONNABORTED" || err.code === "ERR_NETWORK";
                        shouldRetryTimeout = isNetworkError && Boolean(retryTimeout);
                    }
                    if (isUnderLimit && (shouldRetryStatus || shouldRetryTimeout)) {
                        return [
                            2,
                            retryRequest({
                                config: err.config,
                                httpClient: httpClient,
                                retryDelay: retryDelay,
                                hasRetriedCount: hasRetriedCount
                            })
                        ];
                    }
                }
            }
            throw err;
        });
    });
}
export var setResRetryInterceptor = function(httpClient, retryOptions, options) {
    if (options === void 0) options = {};
    var _options_onSuccess = options.onSuccess, onSuccess = _options_onSuccess === void 0 ? function(response) {
        return response;
    } : _options_onSuccess, _options_onError = options.onError, onError = _options_onError === void 0 ? handleRequestRetryError(httpClient, retryOptions) : _options_onError;
    return httpClient.axios.interceptors.response.use(onSuccess, onError);
};
